import React from 'react';
import { BarChart3 } from 'lucide-react';

export const PipelineChart = ({ STAGES, STAGE_COLORS, getStageDeals, getStageTotal }) => {
  const maxVal = Math.max(...STAGES.map(s => getStageTotal(s)), 1);
  return (
    <div data-testid="pipeline-chart" style={{ background: '#0a0a0a', borderBottom: '2px solid #222', padding: '1rem 1.5rem' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
        <BarChart3 size={16} style={{ color: '#6A0DAD' }} />
        <span style={{ fontFamily: "'Bangers', cursive", fontSize: '1.1rem', color: '#b57aff', letterSpacing: '0.03em' }}>Pipeline Revenue</span>
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end', height: '120px' }}>
        {STAGES.map(stage => {
          const val = getStageTotal(stage);
          const h = Math.max(4, (val / maxVal) * 100);
          const color = STAGE_COLORS[stage];
          const count = getStageDeals(stage).length;
          return (
            <div key={stage} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.25rem' }}>
              <span style={{ fontSize: '0.7rem', fontWeight: 800, color: '#fff' }}>
                ${val >= 1000 ? `${(val / 1000).toFixed(0)}K` : val.toLocaleString()}
              </span>
              <div style={{
                width: '100%', maxWidth: '120px', height: `${h}%`, minHeight: '4px',
                background: `${color}cc`, borderRadius: '4px 4px 0 0',
                border: `1px solid ${color}`, transition: 'height 0.3s',
              }} />
              <span style={{ fontSize: '0.65rem', fontWeight: 700, color, textAlign: 'center', lineHeight: 1.1 }}>
                {stage}
              </span>
              <span style={{ fontSize: '0.6rem', color: '#666', fontWeight: 600 }}>{count} deals</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
